import { render } from "./OpenTripSheetTable.vue?vue&type=template&id=5def7dfd&scoped=true"
import script from "./OpenTripSheetTable.vue?vue&type=script&lang=js"
export * from "./OpenTripSheetTable.vue?vue&type=script&lang=js"

import "./OpenTripSheetTable.vue?vue&type=style&index=0&id=5def7dfd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5def7dfd"]])

export default __exports__